module.exports = __webpack_public_path__ + "img/bigcurls.be8b6136.svg";